export const buildCutOffSaveItem = (params: {
    formState: any;
    addressTypeId: number | null;
    selectedDepartureLocation?: { id: number; name: string };
    selectedArrivalLocation?: { id: number; name: string };
    selectedDistanceRange?: { id: number; name: string };
    selectedDeliveryType?: { deliveryTypeId: number; deliveryTypeTranslated?: string };
}) => {
    const {
        formState,
        addressTypeId,
        selectedDepartureLocation,
        selectedArrivalLocation,
        selectedDistanceRange,
        selectedDeliveryType,
    } = params;

    return {
        departureLocationId: formState?.departureLocationId ? Number(formState.departureLocationId) : null,
        departureLocationName: selectedDepartureLocation?.name ?? '',
        arrivalLocationId: formState?.arrivalLocationId ? Number(formState.arrivalLocationId) : null,
        arrivalLocationName: selectedArrivalLocation?.name ?? '',
        distanceRangeId: formState?.distanceRangeId ? Number(formState.distanceRangeId) : null,
        distanceRangeName: selectedDistanceRange?.name ?? '',
        cutoffTime: formState?.cutoffTime ?? '',
        commitmentDay: formState?.commitmentDay ? Number.parseInt(formState.commitmentDay, 10) : null,
        validFromDate: formState?.validFromDate ?? '',
        validToDate: formState?.validToDate ?? '',
        isActive: formState?.isActive ?? true,
        deliveryType: selectedDeliveryType?.deliveryTypeTranslated ?? '',
        deliveryTypeId: formState?.deliveryTypeId ? Number(formState.deliveryTypeId) : null,
        addressTypeId: addressTypeId,
        addressTypeName: '',
    };
};

export const resolveCutOffSaveErrorMessage = (error: any, fallback: string): string => {
    if (error?.data?.Key) {
        return error.data.Key;
    }
    if (error?.message) {
        return error.message;
    }
    return fallback;
};

export const getEmptyCutOffFormState = () => ({
    shippingCompanyId: '',
    cutoffTime: '',
    commitmentDay: '',
    validFromDate: '',
    validToDate: '',
    isActive: true,
    departureLocationId: '',
    arrivalLocationId: '',
    distanceRangeId: '',
    deliveryTypeId: '',
});
